const en = {
  message: {
    searchpage: 'Search page',
    nickname: "Please enter the title of the work/author's alias.",
    search: 'Search',
    total: '"total',
    relatedworks: 'related works',
    nomore: 'There is no more.',
    votes: 'votes',
    loading: 'Loading',
    nodata: 'No data available',
    solicitation: 'Voting solicitation "welcome to vote!',
    popularityAward: 'Popularity Award',
    activity_upload_works: {
      // videoSize:'',
      want_up: 'I want to sign up',
      up_reg: 'Registration list',
      sign_up: 'I sign up',
      agent: 'Agent registration',
      New_registration: 'New registration',
      competition_area: 'Please select the corresponding race area',
      up_once:
        'The photo & video competition provides the micro-video candidates with copyrighted music A song and guarantees that all authorized music works have been fully authorized by upstream copyright holders. The licensing scope is limited to the competition only and candidates are not allowed to use the music works in scenarios other than the competition. If a candidate violates the agreement in using the authorized music works, the dispute arising therefrom should be borne by the candidate himself, while the organizing committee of the competition should not be held liable for it.',
      Theme_of_the_work: 'Theme of the work',
      Please_select_a_theme: 'Please select a theme',
      work_infom: 'Work information',
      MP_voide: ' Support MP4 format video',
      please: 'Please read before uploading',
      realname: 'Realname',
      speak: 'Ensure that the works meet the requirements',
      pleasename: 'Please enter your real name.',
      idnumber: 'ID number',
      pleaseID: 'Please enter the authentic ID of the author.',
      school: 'School/Institution',
      please_school:
        'Please enter the full name of the school, e.g., Beijing No. 2 Primary School, Shanghai Experimental School',
      pleadeenter: 'Please enter the full name of the school',
      contact: 'Contact Information',
      group: 'Group',
      pleasegroup: 'Please select a group',
      worktype: ' Work Type',
      pleasetype: 'Please select the type of the work',
      worktitle: 'Work Title',
      pleasetitle: 'Please enter the title of your work, and keep it within 30 words.',
      photography: 'Photography location',
      Pleasephotographed: 'Please enter where it was photographed.',
      description: 'Description',
      pleasedescription:
        'Please enter the description of your work, and keep it within 300 words. Before you enter your description, please click on the contribution rules to confirm the description requirements.',
      descriptionworks: 'Please keep your description within 300 words.',
      Pleaseupload: 'Please upload your work.',
      imgroul:
        '1. The original size of the picture should be no less than 3Mb, and the compressed size should be within 2-10Mb. 2. Do not use technical synthesis to the original picture, do not add or delete any content of the picture, do not use excessive color processing, and only basic adjustments like cropping and brightness adjustment are allowed.',
      opJPG: 'Please upload your file in JPG format.',
      opscientific: 'Please upload your scientific works.',
      scworks: 'Scientific works',
      pleasephoto: 'Please upload 5 picture works by following the submission rules.',
      programming: 'Please upload your creative programming works.',
      greative: 'Creative programming',
      plerasemp4: 'Please upload your video in .mp4 format.',
      plworke: 'Please upload your work.',
      plvideo: 'Please upload your video.',
      mpgmov: 'Please upload your files in .mpg and .mov here.',
      upvideo: 'Upload your video',
      sub_des: 'Sub-description',
      photo_tip: 'Please describe the picture and keep it within 100 words.',
      region: 'Region',
      clickcity: 'Click to select a city',
      byagree: 'By contributing, you agree to the .',
      sprules: 'statement of rights and responsibilities',
      myagree: 'I have read and agreed to the.',
      contribution: ' Contribution Agreement',
      con_Id: 'I have confirmed the author‘ s ID information to be authentic.',
      submit: 'Submit',
      con_rules: 'Contribution rules',
      laseId: 'The last check code of ID number is not correct.',
      onlucarry:
        'Your ID should only carry the length of 15 or 18, and the first two digits should be valid administrative division codes.',
      phone_null: 'The phone number cannot be empty.',
      phone_rules: 'Please enter your phone number in the correct format.',
      Id_null: 'ID number cannot be empty.',
      enter_id: 'Please enter your ID in the correct format.',
      file_1g: 'Your file size cannot be more than 1G.',
      up_pic: 'Upload your graphic & text works',
      up_videos: 'Upload your videos',
      up_photo: 'Upload your photos',
      up_pain: 'Upload your paintings',
      up_animation: 'Upload your animations',
      up_scientific: 'Upload your scientific & creative works',
      up_music: 'Upload your music works',
      up_work: 'Upload successful, your work(s) are under review.',
      prompt: 'Prompt',
      up_failed: 'Upload failed, please check your work(s).',
      not_socket: 'Your browser does not support sockets.',
      not_workes: 'Do not upload duplicate works!',
      complete: 'Please complete your information.',
      tick_id: 'Please tick the author’ s authentic ID information.',
      tick_privacy: 'Please tick the Privacy Agreement.',
      work_name: 'Author’s name',
      come_name: 'Please enter the real name of the contestant',
      true_id: 'Please enter the real ID number of the author of the work',

      select_region: 'Please select a division',
      click_region: 'Click to select the Division',
      real_id: 'I have confirmed the real ID information of the author',
      real_to_name: 'Confirm registration',
      suc_reg: 'Successful registration',
      fail_reg: 'Registration failed, please try again later',
      please_rele: 'Please complete the relevant information.',
      please_trueid: 'Please check the real ID information of the author.',
      suc_select: 'You have successfully registered, please select',
      mision_works: 'Upload',
      activity_home: 'Activity Homepage',
      no_add: 'There is no registration information, please add it quickly',
      // photo_tip:'Please enter the picture description',
      under_unview: 'You have contributed, and your work is under review'
    },
    user: {
      profile: 'Profile',
      photo: 'Photos',
      alias: 'Alisa',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      phonenumber: 'Phone number',
      pleasenumber: 'Please enter your phone number.',
      address: 'Mailing address',
      enterphone: 'Please enter your phone number.',
      submit: 'Submit',
      logout: 'Log out',
      phone_null: 'The phone number cannot be empty.',
      rulesph: 'Please enter your phone number in the correct format.',
      logged: 'You have logged out.',
      sub_succ: 'Submitted successfully.',
      sub_later: 'Failed to submit. Please try again later.',
      com_mation: 'Please complete your information.',
      my: 'My',
      activity: 'Activity',
      News: 'News',
      journal: 'Journal',
      mywork: 'My work',
      no_more: 'No more',
      ticket: 'ticket',
      no_data: 'No data temporarily',
      my_crea: 'My certificate',
      no_crea: 'You don’t have a certificate yet',
      my_award: 'My award',
      no_award: 'You haven’t won the prize yet',
      download: 'download',
      share: 'share',
      copy_suc: 'Copy successful',
      copy_failed: 'copy failed',
      message_list: 'Message list',
      no_have: 'You haven’t',
      oh: 'oh'
    },
    explain: {
      txt_xon: 'Graphic & Text Contributio',
      g_txt: 'Graphic & Text',
      voide_con: 'Videos Contribution',
      voide: 'Videos',
      photo_con: 'Photography Contribution',
      photo: 'Photos',
      pain_con: 'Paintings Contribution',
      pain: 'Paintings',
      animation_con: 'Animation submission',
      animation: 'Animation',
      scienfic: 'Scientific  Contribution',
      sci_work: 'Scientific',
      music: 'Music contribution',
      sci_music: 'Music'
    },
    explainTwo: {
      g_txt: 'Graphic & Text',
      video: 'Video',
      photo: 'Photos',
      pain: 'Paintings',
      animation: 'Animation',
      sci_work: 'Scientific',
      sci_music: 'Music'
    },
    my: {
      me: 'My',
      event: 'Event',
      log: 'Please log in first.',
      entry: 'My Entry',
      prize: 'My Prize',
      certificate: 'My certificate',
      messages: 'Message notification',
      certification: 'certification',
      logged: 'You are not logged in. Please log in first.',
      award_tuned: 'The prize-winning works are under development, please stay tuned.',
      myNews: 'My news',
      manuscript: 'manuscript',
      signingCertification: 'Signing certification',
      submissionTime: 'Submission time',
      previewPending: 'Preview pending',
      reviewPending: 'Review pending',
      finalReviewPending: 'Final review pending',
      finalReviewPassed: 'Final review passed',
      finalReviewRejected: 'Final review rejected',
      backTip: 'Rejected manuscripts can be re-uploaded after modification'
    },
    activity_signUp: {
      submit: 'Submit',
      con_rules: 'Contribution rules',
      phone_null: 'The phone number cannot be empty.',
      enter_phone: 'Please enter your phone number in the correct format.',
      Id_null: 'ID number cannot be empty.',
      enter_Id: 'lease enter your ID in the correct format.',
      please_mp4: 'Please upload your video in mp4 format.',
      file_1g: 'Your file size cannot be more than 1G. ',
      up_succ: 'Upload successful, your work(s) are under review.',
      prompt: 'Prompt',
      up_failed: 'Upload failed, please check your work(s).',
      not_sockets: 'Your browser does not support sockets.',
      not_worke: 'Do not upload duplicate works!',
      please_com: 'Please complete your information.',
      tick_privary: 'Please tick the Privacy Agreement.',
      personalCertification: `
      <h4>签约条款 </h4>
      <h4>用户在申请和使用本系统时，必须遵守本用户协议。您只有完全接受以下所有服务条款后，才能继续注册申请手续。一旦您完成注册申请，本网可以认为您已经详细阅读并确认同意接受本用户协议的所有条款。</h4>
      <p>我承诺接受以下条款：</p>
      <p>一、用户在注册申请时自愿提供准确而详尽的个人资料，如个人资料有任何变动，必须及时更新；如果用户提供的个人资料不准确、不真实、不合法，本网保留结束用户使用本网各项服务的权利；由于用户提供的个人资料不准确、不真实、不合法所造成的损失，完全由用户本人承担；</p>
      <p>二、用户对所申请的帐号和密码安全负全部责任；本网尽量采取完备的网络安全措施，但是不能承担万一发生黑客攻击对用户造成的损失；用户若发现任何非法使用自己帐号或其它安全漏洞的情况，应立即通知本网；</p>
      <p>三、用户使用本网传输图文文件，须单方面承担对文件内容所应负的所有法律责任，包括核实影像内容的真实性，不侵犯他人肖像权和著作权等；</p>
      <p>四、本网保留随时修改或中断服务而不需通知用户的权利。用户接受本网行使修改或中断服务的权利，本网不需对用户或第三方负责；</p>
      <p>五、与本网签约的摄影师用户，本网有权将其图片介绍给使用客户。摄影师提供的图片，应符合本网所要求的技术参数，并应为每张图片提供符合本网标准的文字说明；</p>
      <p>六、摄影师用户授权本网拥有全球范围内的以下权利：有权从计算机硬盘、软盘、CD-ROM、数据库、网络服务器上编辑、储存用户图片；有权复制、展示和出售用户图片，并向各类国际互联网网站、报纸、杂志、广播电视、电子出版物以及其他现存和未来发展产生的的媒体提供相关的图片产品；有权制订用户图片的销售价格；有权批准和授权第三者使用上述权利；</p>
      <p>七、摄影师用户同意授权本网为在国际互联网上进行用户图片销售的唯一代理机构，即用户不得再将图片授权给其他与本网同样性质的网络图片代理机构使用，但仍拥有将图片直接出售给其他终端使用者的机构或个人的权利。若用户违反此条规定，本网有权单方解除本协议，本网同时保留向用户索赔经济损失的权利；</p>
      <p>八、摄影师用户同意在与本网解约后，本网不再享有唯一代理权，但仍有权存储和销售用户在本协议有效期间提供的图片的权利，并按原协议约定的条件向用户支付稿酬，同时用户亦可授权其他与本网同样性质的网络图片代理机构销售用户图片；</p>
      <p>九、摄影师用户保证对所提供的每张图片均拥有完整的合法的版权，用户图片不应涉及侵犯他人著作权、商标权、名誉权、隐私权及其它违法的内容。摄影师用户应对其所提供图片的违法内容所造成的一切后果承担相应的法律责任；</p>
      <p>十、如果发生第三人未经甲、乙任何一方授权而使用用户图片或其他对用户图片侵权的情形，则摄影师用户同意授权本网与第三方进行交涉；</p>
      <p>十一、为了扩大知名度，摄影师用户同意授权本网（“新摄荟”摄影平台，网址：http://zxp.mlyunai.com/）以及本网的所有权者免费使用并传播摄影师用户上传的图片的缩略图，鉴于目前网络未经同意转载图片缩略图的现象众多，摄影师用户同意放弃索取互联网上缩略图使用费的权利；</p>
      <p>十二、本网对摄影师实行累计付酬制，即按每张照片在本网被用户下载的次数多次付酬，但本网的所有权者可以在一次性付费的前提下，将摄影师用户提供的图片作为对外宣传通稿向海外播发；</p>
      <p>十三、本网拒绝向本网用户提供任何类型的担保；</p>
      <p>十四、用户承诺在使用本网提供的服务时，遵守所有适用于本网服务的地方法律、国家法律和国际法律。用户承诺：</p>
      <p>A、在本网的网页上发布信息或者利用本网的服务时必须符合中国有关法规，不得在本网的网页上或者利用本网的服务制作、复制、发布、传播以下信息：</p>
      <p>a) 反对宪法所确定的基本原则的；</p>
      <p>b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>c) 损害国家荣誉和利益的；</p>
      <p>d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>i) 含有法律、行政法规禁止的其他内容的。</p>
      <p>B、在本网的网页上发布信息或者利用本网的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</p>
      <p>C、不利用本网的服务从事以下活动：</p>
      <p>a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
      <p>b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
      <p>c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
      <p>d) 故意制作、传播计算机病毒等破坏性程序的；</p>
      <p>e) 其他危害计算机信息网络安全的行为。</p>
      <p>D、不以任何方式干扰本网的服务。</p>
      <p>E、遵守本网的所有其他规定和程序。</p>
      <p>用户需对自己在使用本网服务过程中的行为承担法律责任。用户理解，如果本网发现其网站传输的信息明显属于上述第十四条A款所列内容之一，依据中国法律，本网有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。</p>
      <p>若用户的行为不符合以上提到的服务条款，本网将作出独立判断立即取消用户服务帐号。</p>
      <p>十五、用户或本网可随时根据实际情况中断服务。本网不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对后来的条款修改有异议，或对本网服务不满，用户只有以下的追索权：</p>
      <p>a) 不再使用本网服务；</p>
      <p>b) 结束用户使用本网服务的资格；</p>
      <p>c) 通告本网停止该用户的服务。</p>
      <p>结束用户服务后，用户使用本网服务的权利马上中止。从那时起，本网不再对用户承担任何义务。</p>
      `,
      enterpriseCertification: `
      <h4>签约条款 </h4>
      <h4>用户在申请和使用本系统时，必须遵守本用户协议。您只有完全接受以下所有服务条款后，才能继续注册申请手续。一旦您完成注册申请，本网可以认为您已经详细阅读并确认同意接受本用户协议的所有条款。</h4>
      <p>我承诺接受以下条款：</p>
      <p>一、用户在注册申请时自愿提供准确而详尽的个人资料，如个人资料有任何变动，必须及时更新；如果用户提供的个人资料不准确、不真实、不合法，本网保留结束用户使用本网各项服务的权利；由于用户提供的个人资料不准确、不真实、不合法所造成的损失，完全由用户本人承担；</p>
      <p>二、用户对所申请的帐号和密码安全负全部责任；本网尽量采取完备的网络安全措施，但是不能承担万一发生黑客攻击对用户造成的损失；用户若发现任何非法使用自己帐号或其它安全漏洞的情况，应立即通知本网；</p>
      <p>三、用户使用本网传输图文文件，须单方面承担对文件内容所应负的所有法律责任，包括核实影像内容的真实性，不侵犯他人肖像权和著作权等；</p>
      <p>四、本网保留随时修改或中断服务而不需通知用户的权利。用户接受本网行使修改或中断服务的权利，本网不需对用户或第三方负责；</p>
      <p>五、与本网签约的摄影师用户，本网有权将其图片介绍给使用客户。摄影师提供的图片，应符合本网所要求的技术参数，并应为每张图片提供符合本网标准的文字说明；</p>
      <p>六、摄影师用户授权本网拥有全球范围内的以下权利：有权从计算机硬盘、软盘、CD-ROM、数据库、网络服务器上编辑、储存用户图片；有权复制、展示和出售用户图片，并向各类国际互联网网站、报纸、杂志、广播电视、电子出版物以及其他现存和未来发展产生的的媒体提供相关的图片产品；有权制订用户图片的销售价格；有权批准和授权第三者使用上述权利；</p>
      <p>七、摄影师用户同意授权本网为在国际互联网上进行用户图片销售的唯一代理机构，即用户不得再将图片授权给其他与本网同样性质的网络图片代理机构使用，但仍拥有将图片直接出售给其他终端使用者的机构或个人的权利。若用户违反此条规定，本网有权单方解除本协议，本网同时保留向用户索赔经济损失的权利；</p>
      <p>八、摄影师用户同意在与本网解约后，本网不再享有唯一代理权，但仍有权存储和销售用户在本协议有效期间提供的图片的权利，并按原协议约定的条件向用户支付稿酬，同时用户亦可授权其他与本网同样性质的网络图片代理机构销售用户图片；</p>
      <p>九、摄影师用户保证对所提供的每张图片均拥有完整的合法的版权，用户图片不应涉及侵犯他人著作权、商标权、名誉权、隐私权及其它违法的内容。摄影师用户应对其所提供图片的违法内容所造成的一切后果承担相应的法律责任；</p>
      <p>十、如果发生第三人未经甲、乙任何一方授权而使用用户图片或其他对用户图片侵权的情形，则摄影师用户同意授权本网与第三方进行交涉；</p>
      <p>十一、为了扩大知名度，摄影师用户同意授权本网（“新摄荟”摄影平台，网址：http://zxp.mlyunai.com/）以及本网的所有权者免费使用并传播摄影师用户上传的图片的缩略图，鉴于目前网络未经同意转载图片缩略图的现象众多，摄影师用户同意放弃索取互联网上缩略图使用费的权利；</p>
      <p>十二、本网对摄影师实行累计付酬制，即按每张照片在本网被用户下载的次数多次付酬，但本网的所有权者可以在一次性付费的前提下，将摄影师用户提供的图片作为对外宣传通稿向海外播发；</p>
      <p>十三、本网拒绝向本网用户提供任何类型的担保；</p>
      <p>十四、用户承诺在使用本网提供的服务时，遵守所有适用于本网服务的地方法律、国家法律和国际法律。用户承诺：</p>
      <p>A、在本网的网页上发布信息或者利用本网的服务时必须符合中国有关法规，不得在本网的网页上或者利用本网的服务制作、复制、发布、传播以下信息：</p>
      <p>a) 反对宪法所确定的基本原则的；</p>
      <p>b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
      <p>c) 损害国家荣誉和利益的；</p>
      <p>d) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
      <p>e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
      <p>f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
      <p>g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
      <p>h) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
      <p>i) 含有法律、行政法规禁止的其他内容的。</p>
      <p>B、在本网的网页上发布信息或者利用本网的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。</p>
      <p>C、不利用本网的服务从事以下活动：</p>
      <p>a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
      <p>b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
      <p>c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
      <p>d) 故意制作、传播计算机病毒等破坏性程序的；</p>
      <p>e) 其他危害计算机信息网络安全的行为。</p>
      <p>D、不以任何方式干扰本网的服务。</p>
      <p>E、遵守本网的所有其他规定和程序。</p>
      <p>用户需对自己在使用本网服务过程中的行为承担法律责任。用户理解，如果本网发现其网站传输的信息明显属于上述第十四条A款所列内容之一，依据中国法律，本网有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。</p>
      <p>若用户的行为不符合以上提到的服务条款，本网将作出独立判断立即取消用户服务帐号。</p>
      <p>十五、用户或本网可随时根据实际情况中断服务。本网不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对后来的条款修改有异议，或对本网服务不满，用户只有以下的追索权：</p>
      <p>a) 不再使用本网服务；</p>
      <p>b) 结束用户使用本网服务的资格；</p>
      <p>c) 通告本网停止该用户的服务。</p>
      <p>结束用户服务后，用户使用本网服务的权利马上中止。从那时起，本网不再对用户承担任何义务。</p>
      `
    },
    home: {
      yuanjing: 'Yuanjing Cloud Photography Competition Platform',
      p_yuanjing: 'Powered by Yuanjing',
      china_yuanjing: 'Welcome to the Image China Photography Competition！',
      i_all: 'All',
      i_pro: 'Start',
      t_start: 'Wait',
      home_page: 'Home',
      Feedback: 'Feedback of problems',
      ended: 'End',
      partic: ' * people have participated',
      signed: ' * people have signed up',
      dsy_rema: '* days remaining',
      not_start: 'Not started',
      m: 'My',
      votes: '* votes',
      Vote: 'Vote',
      Voted: 'Voted',
      coll: 'Works are being collected.',
      b_top: 'Back to top',
      latest: 'Latest works',
      pop_works: 'Popular works',
      allreg: 'All',
      entry_ready: 'You have already voted for this entry.',
      succ_vote: 'Successful vote',
      network: 'Please check your network.',
      log_first: 'Please log in first.',
      event_start: 'The event has not started.',
      event_ended: 'The event has ended.',
      first_log: 'You are not logged in. Please log in first.',
      work_con: 'Works',
      work_conTwo: 'Works',
      Award_works: 'Awards',
      List_of_Organizations: 'Organization List',
      Introduction: 'Introduction',
      IntroductionTwo: 'Introduction',
      contribute: 'I want to contribute',
      txt_works: 'Graphic & Text Works',
      php_works: 'Photography Works',
      voide_works: 'Video Works',
      pain_works: 'Painting Works',
      animation: 'Animation Works',
      scientific_works: 'Scientific & Creative Works',
      event_details: 'Event Details',
      prize_information: 'Prize information',
      prize_details: 'Prize Details',
      event_not: 'The event has not started.',
      evetn_start: 'The event has ended.',
      event_reg: 'Event Regions',
      entry_details: 'Entry Details',
      up_on: 'Upload on',
      works_in: 'This work is participating in ',
      enter: 'Enter',
      next_group: 'Next group',
      share: 'Share',
      click_friend: 'Click on the upper right corner to share with a friend',
      my_know: 'I know',
      voted_entry: 'You have already voted for this entry.',
      unlike: 'Unlike',
      liked_suc: 'Liked successf',
      next_not: 'No next entry for the moment',
      Relatedlist: 'Related list',
      Tovote: 'To vote',
      surplus: 'Surplus',
      days: 'days',
      Solicitation: 'Solicitation',
      to: 'to',
      total: 'A total of ',
      participated: ' people participated',
      functionz_start: 'Function development in progress',
      onlyvotes10: 'Each person can vote at most 10 votes and only once',
      list: 'List',
      submit_vote: 'Submit a vote',
      voting_tips: 'The activity has ended, and voting is not supported temporarily',
      organizationIntroduction: 'Organization Introduction',
      organizationNoInformation: 'The organization has no profile information'
    },
    //我的获奖-我的证书-入围获奖证书-消息列表
    awarded: {
      registration: 'Information registration form of shortlisted works',
      au_name: 'Author’s name',
      gender: 'Gender',
      age: 'Age',
      school_name: 'School / institution name',
      Division: 'Division',
      group: 'Group',
      Telephone: 'Telephone',
      address: 'Address',
      Company: 'Courier Services Company',
      odd_num: 'Odd Numbers',
      sub_suc: 'Submitted successfully',
      winning: 'Information registration form of winning authors',
      select: 'Please select',
      Category: 'Category of works',
      please_enter: 'Please enter',
      correct: 'Please enter the correct mobile number',
      name_work: 'Name of work',
      one_three: 'Lower grade group of primary school (Grades 1-3)',
      si_liu: 'Upper grade group of primary school (grades 4-6)',
      groub_one: 'Junior high school group',
      groub_two: 'High school group',
      activity_name: 'Activity name'
    },
    //登录-注册-修改密码-忘记密码
    login: {
      lo_reg: 'Login / registration',
      select_log_reg: 'Select login / registration method',
      log_num: 'Login / register with mobile number',
      log_wet: 'Login / register with wechat',
      agree_read: 'I have read and agree to use the agreement and',
      privacy: 'Privacy policy',
      check_agree: 'Please check the privacy agreement',
      log_phone: 'Mobile login',
      log_pass: 'Password login',
      please_phone: 'Please enter your phone number.',
      enter_code: 'Please enter the verification code.',
      please_pass: 'Please enter the password.',
      pass_null: 'Password cannot be empty.',
      new_pass_null:
        'A new password of 8-20 characters. It must contain numbers and lowercase letters.',
      correct_phone: 'Please enter your phone number in the correct format. ',
      sent_succ: 'Sent successfully, please check.',
      resend: 'Resend',
      failed_send: 'Failed to send',
      ver_code: 'Please enter the verification code.',
      reg_suc_log: 'Your registration is successful, please retry to log in.',
      please_com: 'Please complete your information.',
      no_pass: 'Inconsistent passwords',
      sign: 'Log in',
      account_reg: 'No account? Go register',
      forget_pass: 'Forget password',
      send_code: 'Send verification code',
      phone_null: 'Mobile number cannot be empty',
      login_suc: 'Login successful',
      page_jump: 'Page Jump in progress',
      num_reg: 'Mobile number registration',
      en_pass: 'Please enter the 8-16 digit password with English and numbers',
      name_plase: 'Please enter a nickname',
      name_null: 'Nickname cannot be empty',
      acc_reg: 'Account registration',
      pain_again: 'Please enter the password again',
      chang_suc: 'Password changed successfully',
      rest_pass: 'reset password',
      register: 'register',
      agreement: {
        texts: `
      <h4>影像大赛网络服务使用协议 </h4>
      <h4>Photography Contest Network Service Agreement</h4>
      <p>1. 特别提示</p>
      <p>1. Special Reminder</p>
      <p>1.1 本网站举办的影像大赛同意按照本协议的规定及其不时发布的操作规则提供基于互联网以及移动网相关服务（以下称"网络服务"）。为获得网络服务，服务使用人（以下称"用户"）同意遵守本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击"同意"按钮即表示用户完全接受本协议项下的全部条款。</p>
      <p>1.1 The Photography Contest held by this website (hereinafter "Contest") will follow the provisions of this Agreement and the operation rules published from time to time to provide relevant services based on the Internet and mobile network (hereinafter "Network Service"). To obtain Network Service, the service user (hereinafter "User") agrees to abide by all clauses of this Agreement and complete the entire registration as per the prompts on this page. During registration, clicking "Yes" means to totally accept all clauses hereunder.</p>
      <p>1.2 用户注册成功后，影像大赛将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。</p>
      <p>1.2 Upon successful registration, the Contest will give each User an account and relevant password which shall be kept by User; and User shall be responsible for all activities and incidents of his/her account.</p>
      <p>2. 服务内容</p>
      <p>2. Service Content</p>
      <p>2.1 大赛网络服务的具体内容由影像大赛根据实际情况提供，例如搜索、资讯、分享、竞赛和活动等。</p>
      <p>2.1 The Network Service includes specifically the contents provided by the Contest based on actual conditions, such as search, news, sharing, competition and events.</p>
      <p>2.2 用户理解，影像大赛仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由用户自行负担。</p>
      <p>2.2 User understands that the Contest provides only relevant Network Service and other than that, the equipment relating thereto (such as personal computer, other devices relating to the access of the Internet or mobile network) and the expenses needed (such as the phone bill and network fee paid for the Internet access) shall be borne by User.</p>
      <p>3. 服务变更、中断或终止</p>
      <p>3. Change, Interruption or Termination of Service</p>
      <p>3.1 鉴于网络服务的特殊性，用户同意影像大赛有权随时变更、中断或终止部分或全部的网络服务。如变更、中断或终止的网络服务属于免费网络服务，影像大赛无需通知用户，也无需对任何用户或任何第三方承担任何责任。</p>
      <p>3.1 Given the special characteristics of Network Service, User agrees that the Contest is entitled to change, interrupt or terminate the Network Service by whole or by part at any time. If the Network Service so changed, interrupted or terminated is free, the Contest needs to send no further notice to User and bears no responsibility to any User or third party.</p>
      <p>3.2 用户理解，影像大赛需要定期或不定期地对提供网络服务的平台（如互联网网站）或相关的设备进行检修或者维护，如因此类情况而造成网络服务在合理时间内的中断，影像大赛无需为此承担任何责任，但影像大赛应尽可能事先进行通告。</p>
      <p>3.2 User understands that the Contest needs to check or maintain the platform providing the Network Service (such as the Internet website) or relevant equipment on a regular or irregular basis. In the event of any interruption thereof within a reasonable period due to the aforesaid causes, the Contest shall bear no responsibility in this regard provided that a prior notice shall be made public thereby as far as possible.</p>
      <p>3.3 如发生下列任何一种情形，影像大赛有权随时中断或终止向用户提供本协议项下的网络服务而无需对用户或任何第三方承担任何责任：</p>
      <p>3.3 In the event of any of the following circumstances, the Contest may interrupt or terminate at any time the Network Service provided hereunder without bearing any responsibility to User or any third party:</p>
      <p>3.3.1 用户提供的个人资料不真实；</p>
      <p>3.3.1 User provides untruthful personal information;</p>
      <p>3.3.2 用户违反本协议中规定的使用规则；</p>
      <p>3.3.2 User violates the rules of usage provided herein;</p>
      <p>4. 使用规则</p>
      <p>4. Rules of Usage</p>
      <p>4.1 用户在申请使用影像大赛网络服务时，必须向影像大赛提供准确的个人资料，如个人资料有任何变动，必须及时更新。</p>
      <p>4.1 User, when applying to use the Network Service of the Contest, must provide accurate personal information thereto and shall timely update such in the event of any change.</p>
      <p>4.2 用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知影像大赛。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，影像大赛不承担任何责任。</p>
      <p>4.2 User shall refrain from transferring or lending the account and password to others. User shall notify the Contest immediately upon discovery of any illegal usage of his/her account. The Contest shall be exempted from bearing any responsibility in the event of any illegal usage of the account and password due to hacking behavior or negligent maintenance by User.</p>
      <p>4.3 用户必须同意接受影像大赛通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。</p>
      <p>4.3 User must agree to receive product promotion or other relevant commercial information sent by the Contest via email or other methods.</p>
      <p>4.4 用户对于其通过影像大赛网络服务上传到影像大赛网站上的作品依法享有版权或版权合法授权及模特肖像权授权、物权授权等其他相关合法权利。用户应同意并遵守以下约定：</p>
      <p>4.4 User is entitled to the copyright or legal authorization of copyright, authorization of the right of portrait of model, authorization of property rights and other relevant lawful rights as to the works uploaded to the website via the Network Service. User shall agree and abide by the following provisions:</p>
      <p>4.4.1 对于用户上传的作品，用户仍保留原有的全部权利；</p>
      <p>4.4.1 User reserves all the original rights to uploaded works;</p>
      <p>4.4.2 影像大赛有权将作品缩略图等使用于本社区以及用户展示、推广的目的，包含但是不限于影像大赛、第三方网站、网络搜索结果、可嵌入代码、印刷品；</p>
      <p>4.4.2 The Contest may use thumbnail or other forms of works for the purpose of display or promotion in its community and among Users, including but not limited to the Contest, third-party websites, network search results, embeddable code and printed materials;</p>
      <p>4.4.3 影像大赛将采用行业内认可的软件和措施，用以限制其他用户或浏览者未经许可任意复制高清晰度的作品。但影像大赛无法保证未经用户许可，其上传的作品不会被他人非法复制。影像大赛不会限制其他用户或浏览者复制网站中的低清晰度作品或缩略图，对此用户应同意并给予影像大赛相应授权；</p>
      <p>4.4.3 The Contest will adopt the software and measures recognized by the industry to restrict other Users or visitors from unauthorized duplication of any high-definition works. However, the Contest can't guarantee that the uploaded works will not be copied by other illegally without the approval of User. The Contest will not restrict other Users or visitors from copying the works in low definition or thumbnails and for that, User shall agree and grant relevant authorization to the Contest;</p>
      <p>4.4.4 用户保证拥有完全的民事行为能力签署本协议，并有权作出本协议项下对影像大赛的授权。</p>
      <p>4.4.4 User shall ensure that he/she has full capacity for civil conduct to sign this Agreement and is entitled to make the authorization hereunder.</p>
      <p>4.5 用户在使用影像大赛网络服务过程中，必须遵循以下原则：</p>
      <p>4.5 During the usage of Network Service, User must abide by the following principles:</p>
      <p>4.5.1 遵守中国有关的法律和法规；</p>
      <p>4.5.1 Abide by relevant laws and regulations of China;</p>
      <p>4.5.2 遵守所有与网络服务有关的网络协议、规定和程序；</p>
      <p>4.5.2 Abide by all network protocols, rules and procedures relating to Network Service;</p>
      <p>4.5.3 不得为任何非法目的而使用网络服务系统；</p>
      <p>4.5.3 Refrain from using the Network Service system for any illegal purposes;</p>
      <p>4.5.4 不得利用影像大赛网络服务系统进行任何可能对互联网正常运转造成不利影响的行为；</p>
      <p>4.5.4 Refrain from using the Network Service system to conduct any activity which may affect the normal operation of the Internet and cause an unfavorable influence;</p>
      <p>4.5.5 不得利用影像大赛提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</p>
      <p>4.5.5 Refrain from using the Network Service to upload, exhibit or communicate any fake, harassing, slandering, abusive, threatening, vulgar, obscene or other illegal information materials;</p>
      <p>4.5.6 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权、肖像权、隐私权、物权或其他任何合法权益；</p>
      <p>4.5.6 Refrain from infringing upon the patent right, copyright, trademark right, right of reputation, right of portrait, right of privacy, property right or any other legal right and interest of any third party;</p>
      <p>4.5.7 不得利用影像大赛网络服务系统进行任何不利于影像大赛的行为；</p>
      <p>4.5.7 Refrain from using the Network Service system to conduct any activity against the Contest;</p>
      <p>4.5.8 如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告影像大赛。</p>
      <p>4.5.8 Notify the Contest immediately of any spotted illegal usage of account or security vulnerability.</p>
      <p>4.6 不得使用刷票软件等对投稿作品进行欺骗性恶意刷票。</p>
      <p>4.6 User shall refrain from conducting any fraudulent or malicious ballot rigging using relevant software.</p>
      <p>4.7 如用户在使用网络服务时违反任何本协议规定，影像大赛或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。</p>
      <p>4.7 If User violates any provision hereof when using the Network Service, the Contest or its authorized person may demand correction or take direct and necessary measures (including but not limited to changing or deleting the contents posted by User, pausing or terminating User's access to the Network Service User) to alleviate the consequences therefrom.</p>
      <p>4.8 影像大赛针对某些特定的影像大赛网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件、短信提醒等）作出的任何声明、通知、警示等内容视为本协议的一部分，用户如使用该等影像大赛网络服务，视为用户同意该等声明、通知、警示的内容。</p>
      <p>4.8 Any declaration, notice, warning and other contents made by the Contest regarding certain specific usage of the Network Service via different channels (including but not limited to web page announcement, email, SMS, etc.) shall be deemed as a part of this Agreement. The usage of the Network Service by User shall constitute as User's consent to such declaration, notice or warning.</p>
      <p>4.9 用户有权随时将上传的作品删除，影像大赛也可删除任何违反本协议规定的作品。在收到用户提交的删除申请后，影像大赛将在合理期限内删除展示在任何第三方网站上的该用户作品。</p>
      <p>4.9 User may delete his/her uploaded work at any time and the Contest may delete any work violating this Agreement. Upon receiving the deletion request submitted by User, the Contest will delete the work in question on any displayed third-party websites within a reasonable period.</p>
      <p>4.10 影像大赛有权将用户上传的作品同步上传至cnsphoto.com中国影像图片网，且中国影像图片网可对作品进行点赞和收藏操作。</p>
      <p>4.10 The Contest is entitled to upload simultaneously the works uploaded by User to CNS Photo (cnsphoto.com) where such works may be liked and added to favorites.</p>
      <p>5. 知识产权</p>
      <p>5. Intellectual Property Rights</p>
      <p>5.1 影像大赛提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。影像大赛不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向用户或任何第三方负责。</p>
      <p>5.1 Any text, picture, graph, audio and/or video material contained in the Network Service is protected by copyright, trademark and/or other property ownership rights. Without the approval of relevant right holders, the aforesaid materials shall not be released, broadcasted, adapted or republished for the purpose of broadcast or release, directly or indirectly, or be used for other commercial purposes. All such materials or any part thereof may only be stored on a computer for personal and non-commercial purposes. The Contest shall not be liable to any User or third party for any delay, inaccuracy, error and omission incurred during generation, transmission or delivery of the aforesaid materials, in part or in whole, or any compensation generated therein or therefrom, of any form.</p>
      <p>5.2 影像大赛为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。</p>
      <p>5.2 All rights of the software (including but not limited to any picture, photo, animation, video, recording, music, text, additional program and supplementary guiding materials contained therein) used by the Contest to provide the Network Service shall belong to the copyright holder thereof. Without the approval thereof, User may not conduct any reverse engineering, decompilation or disassembling.</p>
      <p>5.3 用户保证其上传的作品不得侵犯或违反第三方的版权、专利权、商标权、商业秘密、隐私权、名誉权、肖像权、物权、公开权或其它知识产权或专有权利。</p>
      <p>5.3 User shall guarantee that the works he/she uploaded are in no violation or infringement of any copyright, patent right, trademark right, trade secret, right of privacy, right of reputation, right of portrait, right of property, right of publicity and other IPRs or exclusive rights of any third party.</p>
      <p>6. 隐私保护</p>
      <p>6. Privacy Protection</p>
      <p>6.1 保护用户隐私是影像大赛的一项基本政策，影像大赛保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在影像大赛的非公开内容，但下列情况除外：</p>
      <p>6.1 Protecting user privacy is a basic policy of the Contest and the Contest guarantees that it will not disclose to the public or any third party the registration materials of any User or any non-public content stored when User is using the Network Service, except for the following conditions:</p>
      <p>6.1.1 事先获得用户的明确授权；</p>
      <p>6.1.1 An explicit authorization has been obtained from User in advance;</p>
      <p>6.1.2 根据有关的法律法规要求；</p>
      <p>6.1.2 As required by relevant laws and regulations;</p>
      <p>6.1.3 按照相关政府主管部门的要求；</p>
      <p>6.1.3 As required by relevant government authorities;</p>
      <p>6.1.4 为维护社会公众的利益；</p>
      <p>6.1.4 To maintain the interests of the social public;</p>
      <p>6.1.5 为维护影像大赛的合法权益。</p>
      <p>6.1.5 To maintain the lawful rights and interests of the Contest.</p>
      <p>6.2   影像大赛可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与影像大赛同等的保护用户隐私的责任，则影像大赛有权将用户的注册资料等提供给该第三方。</p>
      <p>6.2 The Contest may work with third parties to provide relevant Network Services. In such event, the Contest may provide the registration materials and other contents of User for such third parties should they agree to bear the same responsibility for protecting User privacy as the Contest.</p>
      <p>6.3 在不透露单个用户隐私资料的前提下，影像大赛有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
      <p>6.3 Without disclosing the private materials of any User, the Contest may analyze and exploit in a commercial sense the entire database of user information.</p>
      <p>7. 免责声明</p>
      <p>7. Disclaimer</p>
      <p>7.1 用户明确同意其使用影像大赛网络服务所存在的风险将完全由其自己承担；因其使用影像大赛网络服务而产生的一切后果也由其自己承担，影像大赛对用户不承担任何责任。</p>
      <p>7.1 User explicitly agrees that all risks from using the Network Service will be borne on his/her own; any and all consequences generated from using the Network Service will be borne on his/her own and the Contest bears no responsibility in this regard.</p>
      <p>7.2 影像大赛不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。</p>
      <p>7.2 The Contest will not guarantee definite satisfaction of Network Service to the needs of User nor will it guarantee the non-interruption, timeliness, security and accuracy of such Service.</p>
      <p>7.3 影像大赛不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由影像大赛实际控制的任何网页上的内容，影像大赛不承担任何责任。</p>
      <p>7.3 The Contest will not ensure the accuracy and completeness of the external links set for the convenience of User and meanwhile, and will bear no responsibility as to the contents on any page beyond the actual control of the Contest as directed by such external links.</p>
      <p>7.4 对于因不可抗力或影像大赛不能控制的原因造成的网络服务中断或其它缺陷，影像大赛不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</p>
      <p>7.4 Interruption or other flaws of the Network Service incurred due to force majeure or reasons beyond the control of the Contest, the Contest will bear no responsibility in this regard but shall try its best to reduce the losses and influences of User caused therefrom.</p>
      <p>7.5 用户同意，对于影像大赛向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，影像大赛无需承担任何责任；</p>
      <p>7.5 User agrees that the Contest shall not bear any responsibility as to any loss caused by or related to the quality defects of the following product or service provided thereby;</p>
      <p>7.5.1 影像大赛向用户免费提供的各项网络服务；</p>
      <p>7.5.1 Different Network Services provided for User for free by the Contest;</p>
      <p>7.5.2 影像大赛向用户赠送的任何产品或者服务。</p>
      <p>7.5.2 Any product or service presented free of cost by the Contest.</p>
      <p>8. 违约赔偿</p>
      <p>8. Responsibility of Default</p>
      <p>8.1 如因影像大赛违反有关法律、法规或本协议项下的任何条款而给用户造成损失，影像大赛同意承担由此造成的损害赔偿责任。</p>
      <p>8.1 The Contest agrees to compensate for any loss of User caused by the violation of the Contest of any provision under relevant laws and regulations or this Agreement.</p>
      <p>8.2 用户同意保障和维护影像大赛及其他用户的利益，如因以下情形给影像大赛及其关联方或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任（包括但不限于律师费用、诉讼费、仲裁费及其他合理费用）：</p>
      <p>8.2 User agrees to safeguard and maintain the interests of the Contest and other Users, and to bear relevant responsibility for compensation (including but not limited to lawyer fee, litigation expense, arbitration fee and other reasonable costs) as to the loss of the Contest and its related parties or any other third person due to the following conditions:</p>
      <p>8.2.1 用户或使用用户帐号的其他人违反有关法律、法规或本协议项下的任何条款；</p>
      <p>8.2.1 User or other person using User's account violates any provision under relevant laws and regulations or this Agreement;</p>
      <p>8.2.2 任何第三人主张作品侵犯、盗用或违反其版权、商标权、专利权、商业秘密、隐私权、名誉权、公开权、肖像权、物权或其它知识产权或专有权利。</p>
      <p>8.2.2 Any third person lodges the claim against infringement, theft or violation of his/her copyright, trademark right, patent right, trade secret, right of privacy, right of reputation, right of publicity, right of portrait, property right or other IPRs or exclusive rights.</p>
      <p>9. 协议修改</p>
      <p>9. Modification of Agreement</p>
      <p>9.1 影像大赛有权随时修改本协议的任何条款，一旦本协议的内容发生变动，影像大赛将会通过适当方式向用户提示修改内容。</p>
      <p>9.1 The Contest is entitled to modify any provision of this Agreement at any time and once this Agreement is modified, the Contest will notify User of such modification in proper manners.</p>
      <p>9.2 如果不同意影像大赛对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受影像大赛对本协议相关条款所做的修改。</p>
      <p>9.2 User may stop the usage of Network Service if he/she disagrees with relevant modifications made. The continuous usage of Network Service will be deemed as acceptance of relevant modifications made.</p>
      <p>10. 通知送达</p>
      <p>10. Delivery of Notice</p>
      <p>10.1 本协议项下影像大赛对于用户所有的通知均可通过网页公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
      <p>10.1 All notifications made to User hereunder may be transmitted by web page announcement, email or regular mail delivery; such notifications will be deemed as delivered on the date of sending.</p>
      <p>10.2 用户对于影像大赛的通知应当通过影像大赛对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
      <p>10.2 Notification of User shall be transmitted to relevant correspondence address, fax number or email officially published by the Contest.</p>
      <p>11. 法律管辖</p>
      <p>11. Legal Jurisdiction</p>
      <p>11.1 本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。</p>
      <p>11.1 The laws of China shall apply to the conclusion, execution and interpretation of this Agreement as well as the settlement of dispute, which shall all be subject to the jurisdiction of people's court in China.</p>
      <p>11.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向影像大赛所在地的人民法院提起诉讼。</p>
      <p>11.2 Any dispute concerning the content or its execution hereof shall be settled by amicable negotiation between both parties; where negotiation fails, either party may bring it to the people's court of the location of the Content.</p>
      <p>12. 其他规定</p>
      <p>12. Miscellaneous</p>
      <p>12.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
      <p>12.1 This Agreement constitutes the complete agreement of both parties concerning the issues agreed and other relevant matters mentioned herein. Other than this Agreement, no other rights are conferred to either party.</p>
      <p>12.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
      <p>12.2 Should any provision hereof become completely or partly invalid or non-executable due to whatever cause, the remaining provisions shall remain effective and binding.</p>
      <p>12.3 本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
      <p>12.3 Titles of this Agreement are set for convenience only and shall be neglected during interpretation.</p>`,
        agreement_title: 'Video Contest Network Service Usage Agreement',
        one: '1.special suggestion',
        h1n1: '1.1 The Video Contest hosted by the Website agrees to provide Internet-based and mobile network-related services (" Network Services ") in accordance with the provisions of this Agreement and operating rules published from time to time. In order to obtain the Network Services, the Service User (hereinafter referred to as "User") agrees to abide by all terms of this Agreement and complete all registration procedures as prompted on the page. When the user clicks the "Agree" button during the registration process, it means that the user fully accepts all the terms of this Agreement.',
        h1n2: '1.2 After successful registration, the video Competition will give each user a user account and the corresponding password, the user account and password are responsible for keeping; Users shall be legally responsible for all activities and events carried out with their user accounts',
        h1n3: '1.3 We pay attention to the protection of minors rights and interests. If you are under 18 years of age, please read and judge whether you agree to this agreement with your guardian. You will be deemed to have obtained the necessary consent of your guardian by clicking the Confirm or other similar button and continuing to use the Service.',
        two: '2.service content',
        h2n1: '2.1 The specific contents of the online service of the competition shall be provided by the Video Competition according to the actual situation, such as search, information, sharing, competition and activities.',
        h2n2: '2.2 The User understands that the Video Competition only provides relevant network services. In addition, the equipment (such as personal computers, other devices related to Internet access or mobile network access) and the fees (such as telephone charges and Internet access fees) related to relevant network services shall be borne by the user.',
        three: '3. Service change, interruption or termination',
        h3n1: '3.1 In view of the particularity of the network service, the USER agrees THAT THE VIDEO Contest has the right to change, interrupt or terminate part or all of the network service at any time. If THE SERVICE IS CHANGED, INTERRUPTED OR TERMINATED, IT IS FREE OF CHARGE. The VIDEO Competition does not need to notify users, nor bear any responsibility to any user or any THIRD party.',
        h3n2: '3.2 users understand the image competition need to regularly or not regularly to provide network services platform (such as the Internet website) or maintenance/repair or related equipment, such as so situation and disrupted network services within a reasonable period of time, no any responsibility to video contest, but the image competition should be notice in advance as much as possible.',
        h3n3: '3.3 In the event of any of the following circumstances, the Video Competition shall have the right to interrupt or terminate the network services provided hereunder to users at any time without any responsibility to users or any third party:',
        h3n3s1: '3.3.1 The personal information provided by the user is untrue;',
        h3n3s2: '3.3.2 The User violates the rules of use set forth herein;',
        four: '4. Rules of use',
        h4n1: '4.1 Users must provide accurate personal data to the Competition when applying for the online services of the Video Contest. If there is any change in personal data, users must update it in time.',
        h4n2: '4.2 User shall not transfer or lend its account number and password to others. If users discover that their account has been illegally used by others, they should immediately notify the Video Contest. The VIDEO COMPETITION will NOT BE RESPONSIBLE FOR ANY ILLEGAL USE OF THE ACCOUNT OR PASSWORD due TO hacking OR user negligence.',
        h4n3: '4.3 Users must agree to accept the video Contest to send promotional or other relevant business information to users through email or other means.',
        h4n4: '4.4 Users shall have copyright or legal authorization of copyright, authorization of portrait right of models, authorization of real right and other relevant legal rights for the works uploaded to the website of the video Competition through the network service of the video competition. Users shall agree to and abide by the following covenants:',
        h4n4s1: '4.4.1 For the works uploaded by users, users retain all the original rights;',
        h4n4s2:
          '4.4.2 The Video Contest has the right to use the thumbnails of the works for the purpose of the community and user display and promotion, including but not limited to the video contest, third-party websites, Internet search results, embeddable codes and printed matter;',
        h4n4s3:
          '4.4.3 The Competition will use industry-approved software and measures to restrict unauthorized reproduction of high definition works by other users or viewers. However, the video contest cannot guarantee that the works uploaded by users will not be copied illegally without their permission. The Video Contest will not restrict other users or visitors from copying low-definition works or thumbnails from the site, and users shall agree to and grant the appropriate authorization to the Video Contest;',
        h4n4s4:
          '4.4.4 The User warrants that he/she has full capacity for civil conduct to sign this Agreement and has the right to authorize the video Contest hereunder.',
        h4n5: ' 4.5 Users must follow the following principles when using the online service of the Video Contest:',
        h4n5s1: '4.5.1 Abide by relevant laws and regulations of China;',
        h4n5s2:
          '4.5.2 Comply with all network protocols, regulations and procedures related to network services;',
        h4n5s3: '4.5.3 The network service system shall not be used for any illegal purpose;',
        h4n5s4:
          '4.5.4 Do not use the network service system of the Video contest to conduct any behavior that may adversely affect the normal operation of the Internet;',
        h4n5s5:
          '4.5.5 The Internet service provided by the video Contest shall not be used to upload, display or disseminate any false, harassing, hurtful, abusive, threatening, vulgar and obscene or any other illegal information and materials;',
        h4n5s6:
          '4.5.6 It shall not infringe the patent right, copyright, trademark right, reputation right, portrait right, privacy, property right or any other legitimate rights and interests of any other third party;',
        h4n5s7:
          '4.5.7 Shall not use the network service system of the video competition to carry out any behavior that is not conducive to the video competition;',
        h4n5s8:
          '4.5.8 If any illegal use of user accounts or account security vulnerabilities are found, the video Competition shall be notified immediately.',
        h4n6: '4.6 Fraudulent and malicious ticket brushing software shall not be used for the submitted works.',
        h4n7: '4.7 if user when using web services in violation of any provisions of this agreement, the image competition or its authorized person shall have the right to require the user to correct or directly to take all necessary measures (including but not limited to change or delete users to post content and so on, to suspend or terminate the users authority to use web services) to alleviate the impact of user behavior.',
        h4n8: '4.8 image competition for some specific image series network services used by various means (including but not limited to web announcement, E-mail, SMS alerts, etc.) to make any statement, notification, warning content as part of this agreement, such as user contest web services such as the use of the image, as the user agrees to the content of such statement, notification, warning.',
        h4n9: '4.9 Users have the right to delete the uploaded works at any time. The Video Competition may also delete any works that violate the provisions of this Agreement. Upon receipt of a deletion request submitted by the user, the Video Contest will remove the Users work displayed on any third party website within a reasonable period of time.',
        h4n10:
          '4.10 The organizing party shall have the right to upload the works uploaded by users to CNsphoto.com for display and sale. Cnsphoto.com shall regard the works of the contracted photographers. If any third party uses the works, it shall pay the corresponding royalties.',
        five: '5. Intellectual property rights',
        h5n1: '5.1 video contest to provide network services contained in any text, images, graphics, audio and/or video information copyright, trademark and/or other property rights of the protection of the law, without the consent of the holder of the relevant, the above information shall not directly or indirectly in any media published, broadcast, broadcast or publish intentions and rewrite or issue again, Or be used for any other commercial purpose. All such data or any part of it may be kept on a computer only for personal and non-commercial use. The VIDEO CONTEST SHALL NOT BE LIABLE TO THE USER OR any THIRD PARTY IN any WAY FOR ANY delay, inaccuracy, error and omission arising out of or arising from the transmission or submission of all or part of the SAID Data.',
        h5n2: '5.2 All rights in any software (including but not limited to any image, photo, animation, video, audio recording, music, text, additional programs and accompanying help materials contained in the software) used by the Video Contest for the purpose of providing network services belong to the copyright owner of the software, without the permission of the copyright owner of the software. Users may not reverse Engineer, decompile, or disassemble the software.',
        h5n3: '5.3 Users guarantee that their uploaded works shall not infringe or violate the copyright, patent right, trademark right, trade secret, privacy, reputation right, portrait right, property right, publicity right or other intellectual property rights or proprietary rights of any third party.',
        h5n4: '5.4 Apply blockchain and other digital technologies to the works uploaded by users to realize registration, certificate storage and other functions, and provide independent and third-party query and verification services.',
        six: '6. Privacy protection',
        h6n1: '6.1 Protecting user privacy is a basic policy of the Video Competition. The Video Competition guarantees that it will not disclose to the public or provide to any third party the registration information of individual users and the non-public content stored in the Video Competition when users use network services, except for the following situations:',
        h6n1s1: '6.1.1 Obtain the explicit authorization of the user in advance;',
        h6n1s2: '6.1.2 In accordance with relevant laws and regulations;',
        h6n1s3: '6.1.3 In accordance with the requirements of relevant government departments;',
        h6n1s4: '6.1.4 To safeguard the interests of the public;',
        h6n1s5: '6.1.5 To safeguard the legitimate rights and interests of the video contest.',
        h6n2: '6.2 The Video Contest may cooperate with a third party to provide relevant network services to users. In this case, the Video Contest has the right to provide users registration information to the third party if the third party agrees to assume the same responsibility for protecting users privacy as the Video Contest.',
        h6n3: '6.3 On the premise of not disclosing the privacy information of a single user, the Video Competition has the right to analyze the entire user database and make commercial use of the user database.',
        h6n4: '6.4 You confirm and agree to authorize Yuanjingyun Platform, in its own name or in the name of Yuanjingyun Platform or entrust a professional third party to safeguard the rights of the content infringing on your intellectual property rights uploaded and published, including but not limited to: "Yuanjingyun" platform has the right to make decisions on rights protection matters and implement them independently, such as monitoring infringements, sending rights protection letters, filing lawsuits or arbitration, mediation and reconciliation.',
        seven: '7. Disclaimer',
        h7n1: '7.1 The User expressly agrees that the risks arising from the use of the online service of the Video Contest shall be entirely borne by the user; It SHALL also bear all the CONSEQUENCES ARISING FROM its use of THE network services of the VIDEO CONTEST, and the VIDEO Contest shall not bear any responsibility for users.',
        h7n2: '7.2 The Video Competition does not guarantee that the network service can meet the requirements of users, nor does it guarantee that the network service will not be interrupted, nor does it guarantee the timeliness, security and accuracy of the network service.',
        h7n3: '7.3 The Video Competition does not guarantee the accuracy and completeness of the external links set up for the convenience of users, and the Video Competition does not assume any responsibility for the content on any web page that is not under the actual control of the Video Competition.',
        h7n4: '7.4 The Competition does not assume any responsibility for network service interruption or other defects caused by force majeure or reasons beyond the Competitions control. However, the Competition will try its best to reduce the loss and influence caused to users.',
        h7n5: '7.5 The User agrees that the Video Competition shall not bear any responsibility for the quality defects of the following products or services provided to the user and any losses caused by them;',
        h7n5s1: '7.5.1 The free network services provided by the Video contest to users;',
        h7n5s2: '7.5.2 Any products or services presented to users by the Video Contest.',
        eight: '8. Compensation for breach of contract',
        h8n1: '8.1 If the Video Contest violates relevant laws, regulations or any terms of this Agreement and causes losses to users, the Video Contest agrees to bear the liability for damages caused thereby.',
        h8n2: ' 8.2 The User agrees to protect and maintain the interests of the Video Contest and other users. If any loss is caused to the Video Contest, its affiliates or any other third party due to the following circumstances, the User agrees to be liable for damages caused thereby (including but not limited to attorneys fees, legal costs, arbitration fees and other reasonable costs) :',
        h8n2s1:
          '8.2.1 The User or any other person using the User Account violates relevant laws, regulations or any provision of this Agreement;',
        h8n2s2:
          ' 8.2.2 Any third party claims that the work infringes, misappropriates or violates its copyright, trademark right, patent right, trade secret, privacy, reputation right, publicity right, portrait right, property right or other intellectual property rights or proprietary rights.',
        nine: '9. Agreement modification',
        h9n1: '9.1 Video Competition reserves the right to modify any terms of this Agreement at any time. Once the content of this Agreement is changed, Video Competition will notify users to modify the content in an appropriate way.',
        h9n2: '9.2 Users have the right to stop using the Network services if they do not agree with the modification of the relevant terms of this Agreement. If THE USER CONTINUES TO USE THE NETWORK SERVICES, THE USER SHALL BE DEEMED TO HAVE ACCEPTED THE MODIFICATIONS MADE TO THE RELEVANT TERMS OF THIS AGREEMENT.',
        ten: '10. Service of notice',
        h10n1:
          '10.1 All notices of the video Contest under this Agreement can be sent by web bulletin, E-mail or regular mail. Such notice shall be deemed to have been served on the recipient on the date of sending.',
        h10n2:
          '10.2 The notification of the Video Contest shall be sent by the user through the contact information such as the correspondence address, fax number and email address officially published by the Video Contest.',
        eleven: '11. Jurisdiction by law',
        h11n1:
          '11.1 The conclusion, execution and interpretation of this Agreement and the settlement of disputes shall be governed by the laws of China and governed by the courts of China.',
        h11n2:
          '11.2 In case of any dispute between the Parties regarding the content or performance of this Agreement, the parties shall try their best to settle it through friendly negotiation. If the negotiation fails, either party may bring a lawsuit to the peoples court in the place where the competition is located.',
        twelve: '12. Other provisions',
        h12n1:
          '12.1 This Agreement constitutes the entire agreement between the Parties concerning the matters agreed herein and other related matters, and does not confer any other rights to the parties hereto except those set forth herein.',
        h12n2:
          '12.2 If any provision of this Agreement is completely or partially invalid or unenforceable for any reason, the remaining provisions of this Agreement shall remain valid and binding.',
        h12n3:
          '12.3 Headings in this Agreement are for convenience only and shall be ignored in the interpretation of this Agreement.'
      }
    },
    cpn: {
      have: 'already existing',
      people: 'Participate in',
      peop_come: 'People sign up',
      notice: 'Notice',
      cancel: 'cancel',
      coll_works: 'Collection of works',
      all_activity: 'All activities',
      nick_work: 'Please enter the author’s nickname / work name',
      more_division: 'More▼',
      away_all: 'Collapse all ▲',
      head_portrait: 'head portrait',
      be_work: 'Works are being collected',
      no_con: 'No content temporarily',
      voted: 'You have voted for this work.',
      please_log: 'Please login firs',
      not_activity: 'The activity has not started yet',
      end_activity: 'Activity ended',
      of_work: 'Upload',
      bution: 'Contribution',
      expand_all: 'expand all',
      sponsor: 'Sponsor information',
      real_total: 'Related total',
      works: 'works',
      entrance: 'entrance'
    },
    txtpop: {
      h4: 'Statement of rights and responsibilities',
      res_p1:
        '1. The submitted works shall not infringe others copyright, portrait right, reputation right and privacy right. If a third party claims or dissatisfies with the rights of people, buildings or other things in the work, the contributor shall bear full responsibility for the legal affairs caused or likely to be caused by the work.',
      res_p2:
        '2. Works and behaviors that are enough to interfere with public order and good customs will be disqualified once found. "Works and behaviors detrimental to public order and good customs" include but are not limited to all violations of law, morality, public order or good customs that may seriously mislead the public, have the nature of fraud, etc.',
      res_p3:
        '3. No fee will be charged for this activity, and there will be no rejection. The author of the submitted works still retains all rights to the works, and the organizer and the solicitation platform have the right to use the works for non-commercial purposes within the publicity scope of this solicitation activity. The copyright belongs to the author. The submitted works will be awarded to the organizer and its affiliated units for promotional activities. The works will be used through various channels (including but not limited to the Internet, press releases or other media, offline display and promotion activities). The authors signature right will be retained when using the works. The use time is three years, and the use area is unlimited. The organizer is allowed to modify and cut the works (photography, scientific and creative programming).',
      res_p4:
        '4. Once the contestants upload their works, they will be deemed to agree and abide by the above rules. All works that do not meet the requirements of the draft will be disqualified.',
      res_p5: '5. The final interpretation right of this event belongs to the organizer.',
      res_p6: '5、 Precautions',
      res_p7:
        '1. The registration and information filled in by the participants must be true and effective, and the communication must be kept smooth. The organizer will contact the finalists by phone and email and ask them to provide relevant information within the specified date. Those who fail to do so will be deemed to have voluntarily given up.',
      res_p8:
        '2. If the prize winner fails to receive the corresponding remuneration and award certificate due to his failure to provide accurate information, the responsibility shall be borne by the winner himself.'
    },
    // 影像
    news: {
      pageTitle: 'News',
      searchPlaceholder: 'News title/news content/news author',
      backHomepage: 'Return to the first page',
      toMy: 'Jump to my',
      wantContribute: 'I want to contribute',
      contributeNews: 'Contribute news',
      expandAll: 'Expand All',
      putAway: 'Put away',
      author: 'Author',
      Photograph: 'Photograph',
      publishedOn: 'Release time',
      allChannels: 'All Channels',
      realnameTip:
        'You have not performed real-name authentication, and news submission is not supported for the time being, please click Authentication for real-name authentication',
      toCrtification: 'authentication',
      pictureNet: 'PictureNet',
      tabList: [
        'Recommended',
        'Current affairs',
        'Science and education',
        'Economy',
        'Culture',
        'Physical education',
        'Society',
        'Military',
        'Contest',
        'Nature',
        'International',
        'Comics',
        'Hong Kong, Macau and Taiwan',
        'History',
        'Figure',
        'Creativity',
        'China News Agency'
      ],
      cpnTabList: [
        'Recommended',
        'Current affairs',
        'Science and education',
        'Economy',
        'Culture',
        'Physical education',
        'Society',
        'Military',
        'Contest',
        'Nature',
        'International'
      ],
      cpnMoreTabList: [
        'Comics',
        'Hong Kong, Macau and Taiwan',
        'History',
        'Figure',
        'Creativity',
        'China News Agency'
      ],
      PictureName: 'Picture name',
      whole: 'whole',
      authorName: 'Author name',
      authorNamePlaceholder: "Please enter the contributor's real name",
      Headlines: 'Headlines',
      HeadlinesPlaceholder: 'Please enter the news title, within 30 characters',
      newsDetails: 'News details',
      newsDetailsFontSize: '(within 1000 words)',
      newsDetailsPlaceholder: 'Please enter the news description, such as time, news summary',
      filmingLocations: 'Filming locations',
      PleaseChooseTheCity: 'Please choose the city',
      personalInformation: 'Personal information',
      newsInformation: 'News information',
      characterTag: 'Character tag',
      characterPlaceholder: 'Please enter the name of a famous person on the screen',
      keywordTags: 'Keyword tags',
      keywordPlaceholder: 'Please enter keyword tags, separated by multiple commas',
      groupPhotoNotes: 'Group photo notes',
      groupPhotoNotesPlaceholder: 'Please enter group picture remarks',
      authorizeToTheGalleryToEarnRevenue: 'Authorize to the gallery to earn revenue',
      pleaseUploadNewsPictures: 'Please upload news pictures',
      supportedFormats: 'Support jpg/png format, no more than 10M, support batch upload',
      submitTip: 'Uploaded successfully, manuscript pending review',
      albumContribution: 'Album contribution',
      reviewPending: 'Review pending',
      personalCertification: 'Personal certification',
      individualFunction: 'Individual users activate the news contribution function',
      provideAuthentication: 'Provide ID card/passport information for real-name authentication',
      enterpriseCertification: 'Enterprise Certification / Organization Certification',
      enterpriseFunction:
        'Enterprise/organization/institutional users activate the news contribution function',
      provideOrganization: 'Provide organization information for real-name authentication',
      pleaseType: 'Please select the authentication type',
      applyAgain: 'Apply again',
      reviewPassed: 'Review passed',
      personalSigningInformation:
        'Personal signing authentication failed, please select a type and re-upload authentication information',
      Signed: 'Signed',
      applyNow: 'Apply now',
      iDCard: 'ID card',
      clickIDCard: 'Click to take a portrait of the ID card',
      clicEmblemCard: 'Click to take a photo of the national emblem of the ID card',
      realName: 'Real name',
      identified: 'identified',
      iDNumber: 'ID number',
      idFrontalView: require('../../../static/image/1.身份证正面.png'),
      idBacksidePhotograph: require('../../../static/image/2.身份证反面.png'),
      mailingAddress: 'Mailing address',
      PleaseAddress: 'Please enter your mailing address',
      pleaseWorks: 'Please upload your 5 works',
      ihaveRead: 'I have read and agree to the',
      signingAgreement: 'signing agreement',
      submittedTip:
        'Submitted successfully, we will review it for you as soon as possible. You can also submit manuscripts during the review period',
      more: 'More',
      organizationCertification: 'Organization Certification',
      organizationName: 'Organization Name',
      pleaseEnterTheOrganizationName: 'Please enter the organization name',
      contactPerson: 'Real name',
      pleasPerson: 'Please enter the organization real name',
      contactInfo: 'Contact Info',
      pleasePhoneNumber: "Please enter the contact person's phone number",
      categoryDescription: 'Category Description',
      EditPictureDescription: "Edit the picture's description",
      editPersonalProfile: 'Edit personal profile',
      myWorks: 'My works',
      myPrizes: 'My prizes',
      myCertificates: 'My certificates',
      moreToBeAdded: 'More to be added'
    }
  }
  // ...enLocale
}

export default en
